module.exports = require("./../../_gen/starling/utils/Max");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/utils/Max.js
// module id = 247
// module chunks = 0